// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface HarddiskIconSignature {
  Element: SVGSVGElement;
}

export const HarddiskIcon: TOC<HarddiskIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3 20H21C22.103 20 23 19.103 23 18V11C23 9.896 22.103 9 21 9H3C1.897 9 1 9.896 1 11V18C1 19.103 1.897 20 3 20ZM3 18V11H21L21.001 18H3ZM14 14H19V16H14V14ZM6.70711 15.7071C7.09763 15.3166 7.09763 14.6834 6.70711 14.2929C6.31659 13.9024 5.68342 13.9024 5.2929 14.2929C4.90238 14.6834 4.90238 15.3166 5.2929 15.7071C5.68342 16.0976 6.31659 16.0976 6.70711 15.7071Z"/>
</svg>
</template>;